export const COPY = {
  taglines: [
    'a playground for your ideas',
  ],
};
